import { useCallback, useRef, useState } from 'react';

/**
 * Whether a scroll container has been scrolled down, for the header that stays
 * above it to cast a shadow only while content runs beneath it.
 *
 * Put `ref` on the scroll container (or call it with the node yourself).
 */
const useScrolledShadow = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const detachRef = useRef(null);

  const ref = useCallback((node) => {
    detachRef.current?.();
    detachRef.current = null;
    if (!node) return;
    const update = () => setIsScrolled(node.scrollTop > 0);
    update();
    node.addEventListener('scroll', update, { passive: true });
    detachRef.current = () => node.removeEventListener('scroll', update);
  }, []);

  return { ref, isScrolled };
};

export default useScrolledShadow;
